import { useReducer } from "react";
import { parseCoordinates } from "common/utils/coordinates";
import { OmniboxSearchResult } from "../../../generated/graphql";

export type SearchResultsState = {
  debouncedQuery: string | null;
  isTextSearch: boolean | null;
  loading: boolean;
  results: OmniboxSearchResult[] | null;
};

export type SearchResultsAction =
  | {
      type: "searchStarted";
      query: string;
    }
  | {
      type: "searchComplete";
      results: OmniboxSearchResult[] | null;
    }
  | {
      type: "resetSearch";
    };

export const INITIAL_SEARCH_RESULTS_STATE: SearchResultsState = {
  debouncedQuery: null,
  isTextSearch: null,
  loading: false,
  results: null,
};

export const useSearchResultsState = (
  initialState: SearchResultsState = INITIAL_SEARCH_RESULTS_STATE,
) =>
  useReducer((state: SearchResultsState, action: SearchResultsAction) => {
    switch (action.type) {
      case "searchStarted":
        return {
          ...state,
          loading: true,
          isTextSearch: parseCoordinates(action.query) === null,
          debouncedQuery: action.query,
          results: null,
        };
      case "searchComplete":
        return { ...state, results: action.results, loading: false };
      case "resetSearch":
        return INITIAL_SEARCH_RESULTS_STATE;
    }
  }, initialState);
